/**
 *
 * LandingPage
 *
 */

import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { injectIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import colorStroke from '../../images/Color-stroke.png';
import dfn11 from '../../images/landing/crypto-experts.png';
import dfn09 from '../../images/landing/crypto-farming.png';
import dfn10 from '../../images/landing/crypto-fund.png';
import dfn03 from '../../images/landing/crypto-traders.png';
import dfn02 from '../../images/landing/cyrpto-assets-building.png';
import definixOverviewKO from '../../images/landing/definix-overview-kr.png';
import definixOverviewTH from '../../images/landing/definix-overview-th.png';
import definixOverview from '../../images/landing/definix-overview.png';
import dfn08 from '../../images/landing/DEX-LP.png';
import dfn05 from '../../images/landing/liquidity-pool-farm.png';
import dfn04 from '../../images/landing/non-crypto-traders.png';
import dfn06 from '../../images/landing/professional-managed-funds.png';
import dfn07 from '../../images/landing/user-generated-funds.png';
import { Context } from '../../store/lang';
import '../../stylesheets/landing.scss';
import messages from './messages';

function LandingPage({ intl }) {
  const leftPos = useRef(null);
  const [leftPad, setLeftPad] = useState(0);
  const context = useContext(Context);
  const { lang } = useParams();

  useEffect(() => {
    context.lang.set(lang);
  }, [context.lang, lang]);

  const dataS2 = [
    {
      img: dfn04,
      title: intl.formatMessage({ ...messages.s2.non_crypto }),
      detail: intl.formatMessage({ ...messages.s2.non_crypto2 }),
    },
    {
      img: dfn03,
      title: intl.formatMessage({ ...messages.s2.pro_trader }),
      detail: intl.formatMessage({ ...messages.s2.pro_trader2 }),
      other: intl.formatMessage({ ...messages.s2.pro_trader2_bracket }),
    },
  ];

  const dataS3 = [
    {
      img: dfn05,
      title: intl.formatMessage({ ...messages.s3.liquidity_title }),
      detail: intl.formatMessage({ ...messages.s3.liquidity_info }),
    },
    {
      img: dfn06,
      title: intl.formatMessage({ ...messages.s3.invest_title }),
      detail: intl.formatMessage({ ...messages.s3.invest_info }),
    },
    {
      img: dfn07,
      title: intl.formatMessage({ ...messages.s3.user_title }),
      detail: intl.formatMessage({ ...messages.s3.user_info }),
    },
  ];

  const dataS4 = [
    {
      img: dfn08,
      title: intl.formatMessage({ ...messages.s4.dex_title }),
      detail: intl.formatMessage({ ...messages.s4.dex_info }),
      link: 'https://bsc.definix.com',
      isFull: false,
    },
    {
      img: dfn09,
      title: intl.formatMessage({ ...messages.s4.farm_title }),
      detail: intl.formatMessage({ ...messages.s4.farm_info }),
      link: 'https://bsc.definix.com',
      isFull: false,
    },
    {
      img: dfn10,
      title: intl.formatMessage({ ...messages.s4.invest_title }),
      detail: intl.formatMessage({ ...messages.s4.invest_info }),
      link: '',
      isFull: false,
    },
    {
      img: dfn11,
      title: intl.formatMessage({ ...messages.s4.pro_title }),
      detail: intl.formatMessage({ ...messages.s4.pro_info }),
      link: '',
      isFull: true,
    },
  ];

  const dataS6 = [
    {
      title: 'Q1',
      isCurrent: true,
      list: [
        intl.formatMessage({ ...messages.s6.q1.list1 }),
        intl.formatMessage({ ...messages.s6.q1.list2 }),
        intl.formatMessage({ ...messages.s6.q1.list3 }),
      ],
    },
    {
      title: 'Q2',
      isCurrent: false,
      list: [
        intl.formatMessage({ ...messages.s6.q2.list1 }),
        intl.formatMessage({ ...messages.s6.q2.list2 }),
        intl.formatMessage({ ...messages.s6.q2.list3 }),
      ],
    },
    {
      title: 'Q3',
      isCurrent: false,
      list: [
        intl.formatMessage({ ...messages.s6.q3.list1 }),
        intl.formatMessage({ ...messages.s6.q3.list2 }),
        intl.formatMessage({ ...messages.s6.q3.list3 }),
        intl.formatMessage({ ...messages.s6.q3.list4 }),
      ],
    },
    {
      title: 'Q4',
      isCurrent: false,
      list: [intl.formatMessage({ ...messages.s6.q4.list1 })],
    },
  ];

  useEffect(() => {
    setLeftPad(leftPos.current.offsetLeft);
  }, []);

  return (
    <div className="landing-page">
      <section>
        <Container>
          <Grid container alignItems="center">
            <Grid item xs={12} md={6} className="py-2">
              <h1 className="mb-3">
                {intl.formatMessage({ ...messages.s1.advance_your })}
                <br />
                <span className="color-primary">
                  {intl.formatMessage({ ...messages.s1.crypto_assets })}
                </span>
              </h1>
              <p>{intl.formatMessage({ ...messages.s1.detail })}</p>
              <Button
                color="primary"
                variant="contained"
                disableElevation
                href="https://bsc.definix.com"
                target="_blank"
                className="mt-5"
              >
                Launch App
              </Button>
            </Grid>
            <Grid item xs={12} md={6} className="py-2">
              <img src={dfn02} alt="" />
            </Grid>
          </Grid>
        </Container>
        <img src={colorStroke} alt="" className="color-stroke" />
      </section>

      <section>
        <Container>
          <h2>
            {intl.formatMessage({ ...messages.s2.definix_is })}{' '}
            <span className="color-primary">
              {intl.formatMessage({ ...messages.s2.the_best_choice })}
            </span>{' '}
            {intl.formatMessage({ ...messages.s2.for })}
          </h2>
          <Grid container>
            {dataS2.map((d, idx) => (
              <Grid item xs={12} md={6} key={`s2${idx}`}>
                <img src={d.img} alt="" />
                <h4 className="mb-2">{d.title}</h4>
                <p>{d.detail}</p>
                {d.other && <p className="caption">{d.other}</p>}
              </Grid>
            ))}
          </Grid>
        </Container>
      </section>

      <section className="bg-gray">
        <Container>
          {dataS3.map((d, idx) => (
            <div
              className="rotate-content to-h align-start py-6"
              key={`s3${idx}`}
            >
              <img src={d.img} alt="" />
              <div className="content">
                <h3 className="mb-3">{d.title}</h3>
                <p className="ma-0">{d.detail}</p>
              </div>
            </div>
          ))}
        </Container>
        <img src={colorStroke} alt="" className="color-stroke" />
      </section>

      <section>
        <Container>
          <h2 className="mb-6">
            {intl.formatMessage({ ...messages.s4.hello_to })}{' '}
            <span className="color-primary font-size-ultra">
              {intl.formatMessage({ ...messages.s4.definix_v1 })}
            </span>
          </h2>
          <Grid container spacing={4}>
            {dataS4.map((d, idx) => (
              <Grid
                item
                container
                xs={12}
                md={!d.isFull ? 4 : null}
                alignItems={!d.isFull ? 'stretch' : null}
                key={`s4${idx}`}
              >
                <Paper className="px-6 py-7" elevation={2}>
                  <div
                    className={`rotate-content ${
                      d.isFull ? 'to-h align-center' : ''
                    }`}
                  >
                    <img src={d.img} alt="" />
                    <div className="content">
                      <h4 className="mb-2">{d.title}</h4>
                      <p>{d.detail}</p>

                      {d.link !== '' ? (
                        <Button
                          color="primary"
                          variant="contained"
                          disableElevation
                          href={d.link}
                          target="_blank"
                        >
                          Launch App
                        </Button>
                      ) : (
                        <Button variant="outlined" disabled>
                          {intl.formatMessage({ ...messages.s4.coming_soon })}
                        </Button>
                      )}
                    </div>
                  </div>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </section>

      <section className="pt-0">
        <Container>
          <h2>
            {intl.formatMessage({ ...messages.s5.definix })}{' '}
            <span className="color-primary">
              {intl.formatMessage({ ...messages.s5.overview })}
            </span>
          </h2>
          {intl.locale === 'en' && <img src={definixOverview} alt="" />}
          {intl.locale === 'th' && <img src={definixOverviewTH} alt="" />}
          {intl.locale === 'ko' && <img src={definixOverviewKO} alt="" />}
        </Container>
      </section>

      <section className="bg-gray">
        <Container>
          <h2 ref={leftPos}>
            {intl.formatMessage({ ...messages.s6.definix })}{' '}
            <span className="color-primary">
              {intl.formatMessage({ ...messages.s6.milestone })}
            </span>
          </h2>
        </Container>
        <div className="timelines" style={{ paddingLeft: leftPad }}>
          {dataS6.map((t, idx) => (
            <div className="timeline" key={`s6${idx}`}>
              <h1>
                <span className={t.isCurrent ? 'color-primary' : ''}>
                  {t.title}
                </span>{' '}
                2021
              </h1>
              <ul>
                {t.list.map((l, i) => (
                  <li key={`s6L${i}`}>{l}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

LandingPage.propTypes = { intl: PropTypes.object };

export default injectIntl(LandingPage);
